import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Landmark, ArrowRight } from "lucide-react";

export default function BlogList() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    document.title = "Blog — Own Brand Loan Agency Insights | Paisapaid";
    api.get("/public/blog").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []);

  return (
    <div className="app-bg min-h-screen">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-slate-950/80 border-b border-slate-800/70">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5"><span className="h-9 w-9 rounded-lg bg-primary/15 flex items-center justify-center"><Landmark className="h-5 w-5 text-primary" /></span><span className="font-heading font-extrabold text-lg">Paisapaid</span></Link>
          <Link to="/" className="text-sm text-primary flex items-center gap-1.5">Start Your Own Loan Agency <ArrowRight className="h-3.5 w-3.5" /></Link>
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14">
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold">Loan Agency Business Insights</h1>
        <p className="text-slate-400 mt-3 max-w-2xl">Practical guides for loan agents, DSAs, advisors and finance entrepreneurs building their own brand.</p>
        {items === null ? <div className="py-20 flex justify-center"><Landmark className="h-8 w-8 text-primary animate-pulse" /></div> :
         items.length === 0 ? <div className="py-20 text-center text-slate-500">No articles published yet.</div> :
         <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
           {items.map((p) => (
             <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group rounded-2xl border border-slate-800 bg-slate-900/40 overflow-hidden hover:border-primary/40 transition-colors">
               <div className="aspect-[16/9] bg-slate-900 overflow-hidden">{p.featured_image ? <img src={p.featured_image} alt={p.image_alt || p.seo_title} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform" /> : <div className="h-full w-full flex items-center justify-center"><Landmark className="h-8 w-8 text-slate-700" /></div>}</div>
               <div className="p-5">
                 <span className="text-[10px] font-semibold uppercase tracking-wider text-primary">{p.cluster || p.audience}</span>
                 <h2 className="font-heading text-lg font-bold mt-1.5 leading-snug group-hover:text-primary transition-colors">{p.h1 || p.seo_title}</h2>
                 <p className="text-sm text-slate-400 mt-2 line-clamp-3">{p.excerpt}</p>
               </div>
             </Link>))}
         </div>}
      </div>
    </div>
  );
}
